import React from "react";
import Select from "react-select";
import ReactLoading from "react-loading";
import Modal from "../../modal/Modal";
import { useNavigate } from "react-router-dom";

const AddStudentGsrtGradeModal = ({
  showGradePopup,
  setShowGradePopup,
  gradeData,
  staticSection,
  loading,
  studentData,
  selectedStudent,
  setSelectedStudent,
  setStudentData,
  setGradeId,
  setSectionId,
  gradeId,
  studentDetails,
  openStudForm,
  getTranslateText,
}) => {
  const navigate = useNavigate();

  const getTextByKey = (key, fallback) => {
    const item = getTranslateText?.data?.find((item) => item.pageKey === key);
    return item?.keyValue || fallback;
  };

  const handleStudentForm = () => {
    if (!openStudForm) {
      navigate("/user/add_student_form", { state: { selectedStudent } });
    } else {
      openStudForm();
    }
  };
  return (
    <Modal visible={showGradePopup}>
      <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
        <div className="bg-white rounded-2xl shadow-lg w-[500px] p-6 relative pb-[30px]">
          {/* Close Button */}
          <button
            type="button"
            onClick={() => {
              setShowGradePopup(false);
              setStudentData([]);
              setGradeId(null);
              setSectionId(null);
            }}
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
          >
            ✕
          </button>

          {/* Title */}
          <h2 className="text-lg font-semibold text-[#101942] mb-6 text-left">
            {getTextByKey("label_add_student", "Add Student")}
          </h2>

          {/* Dropdowns */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Grade */}
            <div className="flex flex-col">
              <label className="text-sm font-medium text-[#101942] mb-1 text-left">
                {getTextByKey("key_grade", "Grade")}
                <span className="text-red-500">*</span>
              </label>
              <Select
                className="py-2"
                options={gradeData.map((item) => ({
                  value: item.id,
                  label: item.name,
                }))}
                onChange={(val) => {
                  if (val?.value === 12) {
                    setGradeId(11);
                  } else if (val?.value === 13) {
                    setGradeId(12);
                  } else {
                    setGradeId(val?.value);
                  }
                  setStudentData(null);
                }}
              />
            </div>

            {/* Section */}
            <div className="flex flex-col">
              <label className="text-sm font-medium text-[#101942] mb-1 text-left">
                {getTextByKey("key_section", "Section")}
                <span className="text-red-500">*</span>
              </label>
              <Select
                className="py-2"
                options={staticSection.map((item) => ({
                  value: item.id,
                  label: item.name,
                }))}
                onChange={(val) => {
                  setSectionId(val?.label); // ✅ Store the section ID
                  studentDetails(gradeId, val?.label); // ✅ Use the section ID for details
                }}
                isDisabled={!gradeId}
              />
            </div>
          </div>

          {/* Loader */}
          {loading && (
            <div className="flex justify-center items-center h-[200px]">
              <ReactLoading type="spinningBubbles" color="#2e376c" size={40} />
            </div>
          )}

          {!loading && studentData?.length > 0 && (
            <>
              <div className="flex flex-col">
                <label className="text-sm font-medium text-[#101942] mt-3 text-left">
                  {getTextByKey("showing_results", "showing results")}: &nbsp;
                  &nbsp;
                  <span className="text-sm font-medium text-[#FE990D]">
                    {studentData?.length} Students
                  </span>
                </label>
              </div>

              <div className="max-h-[350px] overflow-y-auto pr-2 mt-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {studentData.map((student, index) => (
                    <div
                      key={index}
                      onClick={() => setSelectedStudent(student)}
                      className={`rounded-[12px] cursor-pointer h-fit shadow-[0px_0px_20px_#48456C21] ${
                        selectedStudent?.StudentName === student?.StudentName
                          ? "bg-blue-100 border border-blue-400"
                          : "bg-[#fff]"
                      }`}
                    >
                      <div className="flex flex-row items-center mx-[20px] py-[10px]">
                        <img
                          src="../Images/others.png"
                          alt=""
                          className="rounded-[100%] border-2 w-[40px] h-[40px]"
                        />
                        <div className="flex flex-row justify-between w-full">
                          <div className="flex flex-col text-left pl-[15px]">
                            <a className="cursor-pointer">
                              <p className="mb-[5px] text-[14px]">
                                {student?.StudentName}
                              </p>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="mt-6 flex justify-end gap-4">
                <button
                  type="button"
                  className={`${
                    selectedStudent !== null ? `bg-[#101942]` : `bg-[#D9DBE7]`
                  } text-white text-sm px-6 py-2 rounded-md w-[40%]`}
                  disabled={selectedStudent === null}
                  onClick={() => {
                    setShowGradePopup(false);
                    handleStudentForm();
                  }}
                >
                  {getTextByKey("btn_proceed", "Proceed")}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default AddStudentGsrtGradeModal;
